@use 'ui/styles/core-tokens' as core;

.icon {
  svg {
    flex-shrink: 0;
  }
}

.version {
  box-sizing: border-box;
  margin: -8px 0px 8px;
  overflow: hidden;
  padding: 0px 26px 10px 26px;
  white-space: nowrap;
  width: 100%;

  &Collapsed {
    padding: 10px 5px;
    text-align: center;
  }
}
